import { useContext, useEffect } from "react";
import { Button, Modal, Form, message, Row, Col, Input } from "antd";
import Moment from "react-moment";
import { AuthContext } from "../../../contexts/AuthContext";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { handleFulfillBooking } from "../../../apis/bookings";

export default function FulfillBooking({
  isVisible,
  selected,
  setVisible,
}: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { user } = useContext(AuthContext);

  const isAdvisor = user?.role?.name === "Service Advisor" ? true : false;

  const { mutate: fulfillBooking, isPending } = useMutation({
    mutationFn: handleFulfillBooking,
    onSuccess: () => {
      message.success("Fulfilled Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["bookings"] });
      queryClient.invalidateQueries({ queryKey: ["allCount"] });
      queryClient.invalidateQueries({ queryKey: ["pendingCount"] });
      queryClient.invalidateQueries({ queryKey: ["confirmedCount"] });
      queryClient.invalidateQueries({ queryKey: ["fulfilledCount"] });
      setVisible(false);
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const { wip } = form.getFieldsValue();

    const data = {
      wip,
    };
    await fulfillBooking({ data, _id: selected._id });
  };

  const hideModal = () => {
    setVisible(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [selected]);

  return (
    <Modal
      open={isVisible}
      title="WIP Number"
      onCancel={hideModal}
      footer={[
        <Button key="back" onClick={hideModal}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="UpdateWip"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
        >
          Confirm
        </Button>,
      ]}
      className="z-50"
    >
      <Form
        id="UpdateWip"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
      >
        <div className="pb-2">
          <div className="flex text-black font-bold text-lg">
            VEHICLE: {selected?.title}
          </div>
          <div className="flex ">
            <span className="w-12">Date: </span>
            <Moment format="Do MMM, YYYY">{selected?.date}</Moment>
          </div>
          <div className="flex ">
            <span className="w-12">Time : </span>
            <Moment format="HH:mm A">{selected?.startTime}</Moment>
            <div className="mx-2">-</div>
            <Moment format="HH:mm A">{selected?.endTime}</Moment>
          </div>
        </div>
        <div className="mb-4">Booking No. {selected?.bookingNo}</div>

        {isAdvisor ? null : (
          <div className="mb-8">
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                <Form.Item
                  name="wip"
                  label="WIP Number"
                  layout="vertical"
                  rules={[
                    {
                      required: true,
                      message: "Please select assignee",
                    },
                  ]}
                >
                  <Input type="text" placeholder="WIP" />
                </Form.Item>
              </Col>
            </Row>
          </div>
        )}
      </Form>
    </Modal>
  );
}
